import SettingsMain from "@/views/settings/views/SettingsMain.vue";
import GeneralRoute from "@/views/settings/views/general/router/general.route.js";
import HomeworkStatusRoute from "@/views/settings/views/homework-status/router/homework-status.route";
import EntityGroupRoute from "@/views/settings/views/entity-group/router/entity-group.route.js";
import SettingPayroll from "@/views/settings/views/payroll/router/setting-payroll.router.js";
import RolesByAreaRoute from "@/views/settings/views/roles-area/router/roles-area.router.js";
import AreasByModuleRoute from "@/views/settings/views/areas-module/router/index.js";
import TravelRoutesRoute from "@/views/settings/views/travel-routes/router/travel-routes.router.js";
import ClientsRoute from "@/views/settings/views/clients/clients.router.js";
import VehiclesRoute from "@/views/settings/views/vehicles/router/vechiles.router.js";
import EmpresasRoute from "@/views/settings/views/empresas/router/empresas.route.js";

const routes = [
  {
    path: "/settings",
    name: "settings",
    redirect: { name: "settings-homework-status" },
    meta: { module: 2 },
    component: SettingsMain,
    children: [
      ...GeneralRoute,
      ...HomeworkStatusRoute,
      ...EntityGroupRoute,
      ...SettingPayroll,
      ...RolesByAreaRoute,
      ...AreasByModuleRoute,
      ...TravelRoutesRoute,
      ...ClientsRoute,
      ...VehiclesRoute,
      ...EmpresasRoute
    ]
  },

];

export default routes;
